import { getCityByPrefix } from 'Api/locationApi'
import { getAssociatedCities, submitCities } from 'Api/companyApi'
import { parseCompanyRegion, parseCity } from 'Parsers/regionParser'
import { isRequestCanceled } from 'Services/axiosService'

const state = {
  requesting: {
    associationList: false,
    regionList: false,
    selectedRegions: false,
    association: false,
  },

  selectedCities: [],

  associationList: [],
  regionList: [],
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_region(state, payload) {
    state.selectedRegion = payload
  },

  set_association_list(state, associationList) {
    state.associationList = associationList
  },

  set_region_list(state, regionList) {
    state.regionList = regionList
  },

  set_selected_cities(state, selectedCities) {
    state.selectedCities = selectedCities
  },
}

const actions = {
  async getAssociationList({ commit }) {
    commit('request_start', 'associationList')

    try {
      const { data } = await getAssociatedCities()

      const associationList = data.map(parseCompanyRegion)
      commit('set_association_list', associationList)

      commit('request_success', 'associationList')

      return associationList
    } catch (err) {
      commit('request_failure', 'associationList')
      throw err
    }
  },

  async getSelectedRegions({ commit }) {
    commit('request_start', 'selectedRegions')

    try {
      const { data } = await getAssociatedCities()

      const cityList = data.map(parseCompanyRegion)
      commit('set_selected_cities', cityList)

      commit('request_success', 'selectedRegions')

      return cityList
    } catch (err) {
      commit('request_failure', 'selectedRegions')

      throw err
    }
  },

  async getRegionList({ commit }, prefix) {
    commit('request_start', 'regionList')

    try {
      const { data } = await getCityByPrefix(prefix)

      const regionList = data.map(parseCity)
      commit('set_region_list', regionList)

      commit('request_success', 'regionList')

      return regionList
    } catch (err) {
      if (isRequestCanceled(err)) { return }

      commit('request_failure', 'regionList')

      throw err
    }
  },

  async associateRegions({ commit, state }) {
    commit('request_start', 'association')

    try {

      const { selectedCities } = state

      const cityIdList = selectedCities.map(city => city.idCity)
      const result = await submitCities(cityIdList)

      commit('request_success', 'association')

      return result
    } catch (err) {
      commit('request_failure', 'association')
      throw err
    }
  },

  selectRegion({ commit, state }, region) {
    const { selectedCities } = state

    const cityList = selectedCities.filter(item => item.idCity !== region.idCity)
    cityList.push(region)

    commit('set_selected_cities', cityList)
  },

  removeRegion({ commit, state }, region) {
    const { selectedCities } = state

    const cityList = selectedCities.filter(item => item.idCity !== region.idCity)

    commit('set_selected_cities', cityList)
  }
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}